import PolicyPage from "../components/PolicyPage";

export default function Disclaimer() {
  return (
    <PolicyPage
      kind="disclaimer"
      title="Medical Disclaimer — Information vs. advice."
      intro="The content on this website is general medical information, drafted by Dr. Indresh Dixit's team. It is intended to help patients understand their symptoms and conditions — it is not personalised medical advice, diagnosis or treatment."
      sections={[
        {
          id: "not-medical-advice",
          heading: "This is information, not advice",
          body: "Reading a page about a condition or procedure does not establish a doctor-patient relationship. Every patient's history, examination and test results are different — only an in-person consultation can result in a diagnosis or treatment plan that applies to you specifically.",
        },
        {
          id: "do-not-delay",
          heading: "Do not delay care",
          body: "If you have symptoms that may be urgent — chest pain, severe abdominal pain, vomiting blood, passing black or bloody stools, sudden jaundice, severe weakness, or any condition you are worried about — please call the clinic, visit the nearest emergency department, or dial 112. Do not rely on this website to triage urgent situations.",
        },
        {
          id: "medication",
          heading: "Medication & treatment",
          bullets: [
            "Do not start, stop, or change any medication based purely on what you read here.",
            "Dosages, durations and combinations are individualised to each patient.",
            "Many GI medicines interact with common drugs (blood thinners, NSAIDs, antibiotics). A doctor must review the full list.",
          ],
        },
        {
          id: "videos-and-content",
          heading: "Videos & third-party content",
          body: "Videos embedded from Dr. Indresh Dixit's YouTube channel are also general patient education. Comments and replies on social media should not be treated as personal medical advice. For anything specific to your case, please book a consultation.",
        },
        {
          id: "use-of-images",
          heading: "Photographs of Dr. Dixit",
          body: "Professional images of Dr. Indresh Dixit on this site are used with his permission. Photos of clinics, equipment and procedures (where shown) are representative — actual setup may vary.",
        },
        {
          id: "no-warranty",
          heading: "No warranty",
          body: "While we make best efforts to keep the site accurate and available, we provide it on an 'as-is' basis without any warranty of suitability for a particular purpose. Use of the information on the site is at your own discretion.",
        },
      ]}
    />
  );
}
